"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _i18next = require("i18next");
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _appConfigHelper = require("../../util/appConfigHelper");
var _resetPassword = _interopRequireDefault(require("../../api/Auth/resetPassword"));
var _Button = _interopRequireDefault(require("../Button"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _InnerPopupWrapper = _interopRequireDefault(require("../InnerPopupWrapper"));
var _InnerPopupWrapperStyled = require("../InnerPopupWrapper/InnerPopupWrapperStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditPassword = _ref => {
  let {
    hideInnerPopup,
    customerEmail,
    handleLogout
  } = _ref;
  const [step, setStep] = (0, _react.useState)(1);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [isError, setIsError] = (0, _react.useState)(false);
  const renderNextStep = () => {
    setStep(prevStep => prevStep + 1);
  };
  const logout = () => {
    handleLogout();
    _auth.default.logout();
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_AUTH_FAILED, {
      source: 'EditPassword'
    });
  };
  const handleResetPassword = async () => {
    setIsLoading(true);
    try {
      const {
        publisherId
      } = (0, _jwtDecode.default)((0, _appConfigHelper.getData)('CLEENG_AUTH_TOKEN'));
      const response = await (0, _resetPassword.default)(customerEmail, String(publisherId));
      if (!response.errors.length) {
        renderNextStep();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setIsError(true);
      }
    } catch {
      setIsLoading(false);
      setIsError(true);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapper.default, {
    steps: 2,
    popupTitle: (0, _i18next.t)('Edit Password'),
    isError: isError,
    currentStep: step,
    children: [step === 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          $step: step,
          children: (0, _i18next.t)('Edit Password')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.TextStyled, {
          children: [(0, _i18next.t)("If you want to edit your password, click 'YES, Reset' to receive password reset instruction on your mail"), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.MailStyled, {
            children: [" ", customerEmail, "."]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "simple",
          onClickFn: () => hideInnerPopup(),
          children: (0, _i18next.t)('No, thanks')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: handleResetPassword,
          children: isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            buttonLoader: true,
            color: "#ffffff"
          }) || (0, _i18next.t)('Yes, Reset')
        })]
      })]
    }), step === 2 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          $step: step,
          children: (0, _i18next.t)('Email has been sent!')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: (0, _i18next.t)('Please check your inbox and follow the instructions to reset your password.')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: (0, _i18next.t)('You will be logged out for security reasons.')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: () => logout(),
          children: isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            buttonLoader: true,
            color: "#ffffff"
          }) || (0, _i18next.t)('Confirm')
        })
      })]
    })]
  });
};
var _default = exports.default = EditPassword;